import { render } from "./salidasinventariosrestaurante.vue?vue&type=template&id=3dff8e34&scoped=true"
import script from "./salidasinventariosrestaurante.vue?vue&type=script&lang=js"
export * from "./salidasinventariosrestaurante.vue?vue&type=script&lang=js"

import "./salidasinventariosrestaurante.vue?vue&type=style&index=0&id=3dff8e34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dff8e34"]])

export default __exports__